export const selectFetchRequest = rId => state => state.requests?.errors?.[rId]

export const selectFetchResponse = rId => state => state.responses?.errors?.[rId]

export const selectFetchError = rId => state => state.fetch?.errors?.[rId]
